import Image from 'next/future/image';
import reebeloCareIcon from '@/public/icons/product/circularReebeloCare.svg';

const Icon = () => (
  <div className="h-14 w-14 md:hidden">
    <Image
      src={reebeloCareIcon}
      height={50}
      width={50}
      alt="ReebeloCare"
      className="h-full w-full"
    />
  </div>
);

export default Icon;
